/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { RECEIVED_SERVER_PING } from 'state/auth/AuthActions';
import { GLOBALS } from 'services/globals';

export const versionInitialState = {
  ui: '',
  service: ''
};

export const versionReducer = (state = {}, action) => {
  if (action.type === RECEIVED_SERVER_PING) {
    return {
      ui: window ? GLOBALS.AAM_UI_VERSION_NO : '0.0.0',
      service: action.info.buildVersion
    };
  }
  return state;
};
